

define(['angular', 'text!./template.html', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-ui-components/src/floating-label/directive'], function (angular, template) {

    return angular.module('xo-guest.countryOfResidence', ['squid', 'xo-error-tooltip.directive', 'floating-label-dropdown.directive']).directive('xoCitizenship', function () {
        return {
            template: template,

            scope: {
                user: '='
            },

            controller: function controller($scope, $locale) {
                $scope.locale = $locale;
                $scope.metadata = angular.copy($locale.metadata);
                $scope.countries = $scope.metadata.territory;
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/countryOfResidence/directive.js
// module id = ./components/xo-guest-components/src/guest/countryOfResidence/directive.js
// module chunks = 1